import format from "libphonenumber-js";

export default (value) => (value ? format(value)?.formatInternational() : "");
